<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Unmatch {{ title }}</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body" hsDraggable="modal-dialog">
  <p class="hint">
    This group spans more than one source. Choose which source to unmatch, or
    unmatch the whole group.
  </p>
  <button
    *ngFor="let source of sources"
    type="button"
    class="source-row"
    (click)="choose(source.origin)"
  >
    <span class="dot" [style.background]="source.color"></span>
    <span class="label">Unmatch from {{ source.label }}</span>
    <span class="count">{{ source.count }}</span>
  </button>
</div>
<div class="modal-footer" hsDraggable="modal-dialog">
  <div>
    <button nf-button="cancel" (click)="activeModal.dismiss()"></button>
    <button nf-button="danger" (click)="choose('all')">Unmatch all</button>
  </div>
</div>
